import { useState, useCallback } from 'react'

export const useToast = () => {
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success'
  })

  const showToast = useCallback((message, severity = 'success') => {
    setToast({ open: true, message, severity })
  }, [])

  const hideToast = useCallback(() => {
    setToast((prev) => ({ ...prev, open: false }))
  }, [])

  return { toast, showToast, hideToast }
}
